import { gql } from '@apollo/client'

export const CREATE_JOB_FOLDER = gql`
  mutation createJobFolder($createWorkspaceJobFolderInput: CreateWorkspaceJobFolderInput!) {
    createWorkspaceJobFolder(createWorkspaceJobFolderInput: $createWorkspaceJobFolderInput) {
      id
      name
    }
  }
`
